let requestCount = 0;
let onComplete = null;

export function setAllRequestsCompleteCallback(cb) {
  onComplete = cb;
}

export function incrementRequestCount() {
  requestCount++;
}

export function decrementRequestCount() {
  requestCount = Math.max(0, requestCount - 1);

  if (requestCount === 0 && typeof onComplete === 'function') {
    const cb = onComplete;
    onComplete = null;
    cb();
  }
}
